<template>
  <layout-simple title="Impressum">
    <v-container class="padded">
      <v-card flat>
        <v-card-title> <h1>Impressum</h1> </v-card-title>
        <v-card-text>
          <p class="MsoNormal">
            <b><span lang="DE">Angaben gemäß § 5 TMG</span></b>
          </p>
          <p class="MsoNormal">
            <span lang="DE">
              <ul class="MsoNormal" style="list-style-type: none">
                <li lang="DE">mint software GmbH</li>
                <li lang="DE">Carl-Fischer-Str. 2</li>
                <li lang="DE">49084 Osnabrück</li>
                <li><br /></li>
                <li lang="DE">Telefon: +49 157 81932790</li>
                <li lang="DE">E-Mail: <a href="mailto:info@mmmint.ai">info@mmmint.ai</a></li>
                <li><br /></li>
                <li>Registergericht: Osnabrück</li>
                <li>Registernummer: HRB 215257</li>
                <li>Vertretungsberechtigter Geschäftsführer: Herr Maximilian Stein</li>
                <li>Ust.ID: DE334940239</li>
                <li><br /></li>
                <li lang="DE">Inhaltlich Verantwortlicher gem. § 55 II RStV: Maximilian Stein (Anschrift s.o.)</li>
              </ul>
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Hinweis gemäß Online-Streitbeilegungs-Verordnung</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE">
              Nach geltendem Recht sind wir verpflichtet, Verbraucher auf die Existenz der Europäischen
              Online-Streitbeilegungs-Plattform hinzuweisen, die für die Beilegung von Streitigkeiten genutzt werden
              kann, ohne dass ein Gericht eingeschaltet werden muss. Für die Einrichtung der Plattform ist die
              Europäische Kommission zuständig. Die Europäische Online-Streitbeilegungs-Plattform ist hier zu finden:
              http://ec.europa.eu/odr. Unsere E-Mail lautet: info@mmmint.ai. Wir weisen aber darauf hin, dass wir nicht
              bereit sind, uns am Streitbeilegungsverfahren im Rahmen der Europäischen Online-Streitbeilegungs-Plattform
              zu beteiligen. Nutzen Sie zur Kontaktaufnahme bitte unsere obige E-Mail und Telefonnummer.
            </span>
          </p>

          <p class="MsoNormal">
            <b><span lang="DE">Hinweis gemäß Verbraucherstreitbeilegungsgesetz (VSBG)</span></b>
          </p>

          <p class="MsoNormal">
            <span lang="DE">
              Wir sind nicht bereit und verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </span>
          </p>
        </v-card-text>
      </v-card>
    </v-container>
  </layout-simple>
</template>

<script lang="ts">
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { LayoutSimple }
})
export default class Imprint extends Vue {}
</script>

<style scoped>
.contain {
  width: 100%;
  padding: 1em;
}
</style>
